import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { TopHeader } from "@/components/TopHeader";
import { PublicFooter } from "@/components/PublicFooter";
import { PageTransition } from "@/components/PageTransition";
import {
  useRealtimeBookings,
  useRealtimeNotifications,
  useRealtimeHosts,
} from "@/hooks/useRealtime";

function RealtimeSubscriptions() {
  useRealtimeBookings();
  useRealtimeNotifications();
  useRealtimeHosts();
  return null;
}

export function AppLayout() {
  const location = useLocation();

  return (
    <SidebarProvider>
      <RealtimeSubscriptions />

      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <div className="flex flex-1 flex-col">
          <TopHeader />
          <main className="flex-1 overflow-auto p-6">
            <AnimatePresence mode="wait" initial={false}>
              <PageTransition key={location.pathname}>
                <Outlet />
              </PageTransition>
            </AnimatePresence>
          </main>
          <PublicFooter className="shrink-0" />
        </div>
      </div>
    </SidebarProvider>
  );
}
